module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top-bar"
  }, [_c('div', {
    staticClass: "top-bar-left"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo-small.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "menu-text"
  }, [_vm._v("Adaptive Feed")])], 1), _vm._v(" "), _c('div', {
    staticClass: "top-bar-right"
  }, [_c('ul', {
    staticClass: "dropdown menu",
    attrs: {
      "data-dropdown-menu": ""
    }
  }, [(_vm.isEnabled('feeds')) ? _c('li', {
    class: {
      active: _vm.isActive('/feeds/?')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/feeds"
    }
  }, [_vm._v("Hírfolyamok")])], 1) : _vm._e(), _vm._v(" "), (_vm.isEnabled('analytics')) ? _c('li', {
    class: {
      active: _vm.isActive('/analytics/?')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/analytics"
    }
  }, [_vm._v("Elemzések")])], 1) : _vm._e(), _vm._v(" "), (_vm.isEnabled('insights')) ? _c('li', {
    class: {
      active: _vm.isActive('/insights/?')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/insights"
    }
  }, [_vm._v("Kimutatás")])], 1) : _vm._e(), _vm._v(" "), (_vm.isEnabled('users')) ? _c('li', {
    class: {
      active: _vm.isActive('/users/?')
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_vm._v("Felhasználók")])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fi-power icon-med"
  })])])])])]), _vm._v(" "), (_vm.$breadcrumbs.length) ? _c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "row expanded"
  }, [_c('div', {
    staticClass: "small-8 columns"
  }, [_c('partials-breadcrumbs')], 1), _vm._v(" "), _c('div', {
    staticClass: "small-4 columns text-right"
  }, [_c('partials-actions')], 1)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26b9fa36!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Header.vue
// module id = 466
// module chunks = 2